module.exports = __webpack_public_path__ + "img/sharing.836317cc.svg";